import { Suspense, lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import PageLoader from "components/PageLoader";
import routesPaths from "routes/routesPaths";
import { DetailsPage } from "modules/spaces/ui/pages/DetailsPage";
import SpacesRootRoute from "./SpacesRootRoute";

const SpacesListing = lazy(() =>
  import("../../ui/pages/SpacesListing").then((result) => ({
    default: result.SpacesListing,
  })),
);

const SpaceRoutes = (
  <Route path={routesPaths.spaces} element={<SpacesRootRoute />}>
    <Route
      path={routesPaths.spaces}
      index
      element={
        <Suspense fallback={<PageLoader />}>
          <SpacesListing />
        </Suspense>
      }
    />
    <Route
      path=':model/:name/:id'
      element={
        <Suspense fallback={<PageLoader />}>
          <DetailsPage />
        </Suspense>
      }
    />
    <Route path='*' element={<Navigate replace to='' />} />
  </Route>
);

export default SpaceRoutes;
